import Icon from "../icon/icon";
import React from "react";

export interface ISupportButtonProps {
  href: string;
  icon: string;
  label: string;
  [key: string]: unknown;
}

function SupportButton(props: ISupportButtonProps) {
  const { href, icon, label, ...extraProps } = props;

  return (
    <a className="support-button" href={href} {...extraProps}>
      <Icon className="support-icon">{icon}</Icon>
      <span className="support-label">{label}</span>
    </a>
  );
}

export default SupportButton;
